<template>
    <div v-if="loading" style="text-align:center;padding: 35vh 0 5rem 0; min-height:105vh ; background-color:#f5f5f5">
      <img src="../../../static/LoadingGrey.gif" style=" width:1.2rem ;" />
    </div>

  <div class="pageContent"  v-else  >
    <div class="title"  >
      <mu-appbar style="height:40px;background:url('../../../static/search/roomTopBg.png'); box-shadow:0 0 0 0;">
          <mu-icon value="keyboard_arrow_left" color="white" slot="left"   v-on:click="goback"   style="z-index:999"  />
          <a style='margin-right:0.2rem; z-index:999' v-bind:href="'tel:'+ g_currentInfo.Phone" slot="right"   >
            <mu-icon value="phone" color="white" :size='20'  />
          </a>
          <mu-icon style='top:-2px;position:relative; margin-right:0.1rem;  z-index:999 ' slot="right" :value="starValue" :color="starColor" :size='20' @click="collect" />
      </mu-appbar>
    </div>
    <div class="slider"  style="z-index:0"  v-on:click=" goPage2() ">
      <swiper :options="swiperOption1"   style='height:5.6rem;'    >
        <swiper-slide v-for="pic in g_currentInfo.PicList">
          <img :src="pic.Attachmenturl" class="banner-item" v-on:click=" goPage2() ">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="main" v-if="NowPage==1"  >
      <mu-paper class="demo-paper" :zDepth="1" style='padding:0px'>
        <a href="#/search/hotailDetail">
          <span class="title"> {{g_currentInfo.HotelName}}&nbsp;&nbsp;
            <img src='../../../static/search/rightArr.png' style="height:0.23rem;margin-left:-2px;position:relative;top:1px" />
          </span>
        </a>
        <p>
          <mu-icon value="room" color="#D4D4D4" :size='10' />&nbsp;&nbsp; {{g_currentInfo.Address}}
          <a class="map" href="#/search/mapbook">地图和周边</a>
        </p>
        <p class="hotelLoc">
          <img v-for="ser in g_currentInfo.HotelServiceList" :src="'../../../static/service/' + serviceIcon(ser.KeyId) + '.png'" v-bind:class="serviceIcon(ser.KeyId)" />
        </p>
        <mu-divider />
        <p class="bottom">
          <span class="score">{{g_currentInfo.CommentScore | toFixed}}</span>&nbsp;
          <span class="unit">分</span>
          <span class="stars">

            <!--星星中间不能有空格，所以他们要放在一行-->
            <mu-icon style="position:relative;top:1px;" value="star" color="#FF8F3B" :size='10' v-for="i in fullStar(g_currentInfo.CommentScore)" /><mu-icon style="position:relative;top:1px;" value="star_half" color="#FF8F3B" :size='10' v-if="halfStar(g_currentInfo.CommentScore)" /><mu-icon style="position:relative;top:1px;" value="star_outline" color="#FF8F3B" :size='10' v-for="i in nullStar(g_currentInfo.CommentScore)" />
          
          </span>
          <span class="commont" v-on:click="goCommentList">
            {{g_currentInfo.CommentCount}}条评论
            <mu-icon value="keyboard_arrow_right" color="#D4D4D4" :size='16' style="position:relative;top:4px;" />
          </span>
        </p>
      </mu-paper>
      <!--paper-->
      <div style=' background-color:white'>
                  <!--<span style="float:left ; ">入住</span>-->
          <!--<mu-date-picker   style="float:left"  :maxDate="checkinMaxDate" :minDate="checkinMinDate" v-model="g_searchParam.startDate" :underlineShow='false' @change="checkinDateChange"/>-->
              <!--允许入住时间：{{ firstroom.HourRoomStartTime }}点 - {{ firstroom.HourRoomEndTime }}点-->
  
        <!-- <div>
          <span style=" float:left ; padding: 0.45rem 0rem 0 0.3rem ; color:#666666 ; font-size:0.32rem ">
            入住日期
          </span>
          <div style='position:relative;height:1.4rem;'>
            <mu-date-picker v-model="g_searchParam.arriveDate" hintText="入住日期" :maxDate="checkinMaxDate" :minDate="checkinMinDate" 
            :underlineShow="false" @change="setRelaxDate" style="position:relative;; float:left ; padding:0.2rem 0 0rem 0.5rem ; height:1.2rem ; width:2rem  " id="LiveDate" format='YYYY-MM-DD' />
            <span    style='    position: absolute;    top: 1em;    left: 1.5rem;    color: #666;
            height:1.4rem;line-height:1.1rem;margin-left:1.5em;'>{{arriveDateFormat}}</span>
            <span style="float: right ; margin:0.5rem 0.5rem 0 0  ;color:#666666 ">
              入住时间：{{  g_searchParam.relaxHour  }}点
            </span>
          </div>
        </div> -->

        <div>
          <div style=" float:left ; padding: 0.45rem 0rem 0.2rem 0.3rem ; color:#666666 ; font-size:0.32rem ">
            入住日期
          </div>
          <div style=" float:left ; padding: 0.5rem 0rem 0 0.5rem ; color:#888 ; font-size:0.28rem ">
            {{arriveDateFormat}}
          </div>
          <div style="float: right ; margin:0.5rem 0.5rem 0 0  ;color:#666666 ">
            入住时间：{{  g_searchParam.relaxHour  }}点
          </div>

        </div>

        <mu-divider />
  
        <mu-list v-for="(room,index) in rooms" style=" padding:0px;">
          <mu-list-item v-on:click="open(index)">
            <div style="width:95% ; margin:0 auto 0 auto ">
            <div style=" float:left ;width:45% ;">
              <span style=" float:left ; color:#333 ">{{room.RoomTypeName}}</span>
            </div>
            <div style=" float:left ;width:25% ;">
              <span v-if="room.RoomType==98 || room.RoomType==99" style=" margin-right: 0rem ">
                <span style=" color:#FF8F3B ;    ">
                  <!--<span v-if="room.isMember">￥{{room.MemberPrice}}</span>
                    <span v-if="!room.isMember">￥{{room.NotMemberPrice}}</span>-->
                  <span>￥{{room.bookPrice}}</span>
  
                </span>/4小时
              </span>

              <span v-if="room.RoomType==100 || room.RoomType==101" style=" margin-right: 0rem ">
                <span style=" color:#FF8F3B ;    ">
                  <!--<span v-if="room.isMember">￥{{room.MemberPrice}}</span>
                    <span v-if="!room.isMember">￥{{room.NotMemberPrice}}</span>-->
                  <span>￥{{room.bookPrice}}</span>
  
                </span>/3小时
              </span>
              <span v-if="room.RoomType==102 || room.RoomType==103" style=" margin-right: 0rem ">
                <span style=" color:#FF8F3B ;    ">
                  <span>￥{{room.bookPrice}}</span>
                </span>/2小时
              </span>
  
           </div>
           <div style=" float:left ;width:28% ">
              <input type="button" v-if="room.IsEnableBook" value="预订" v-on:click="goOrderToRelax(room)" style="border-radius: 4px;background-color:#27ba69 ; border:none ; outline:0; float:right ; color:white ; padding:0.1rem 0.2rem ; margin:-0.1rem  " />
              <input type="button" v-if="!room.IsEnableBook" value="满房" style="border-radius: 4px;background-color:#eee ; border:none ; outline:0 ; float:right ; color:#ccc ; padding:0.1rem 0.2rem ; margin:-0.1rem " />
           </div>
        </div>
  
          </mu-list-item>
          <mu-divider />
        </mu-list>
  

        <!--<mu-list-item   :class="{'noRoom': room.AvailRooms <= 0,'isChild': room.IsChild,'firstChild': room.IsChild && !room.ChildPosition}"  v-for="(room,index) in rooms" @click="open(index)">
                  <span class="listTitle">{{room.RoomTypeName}}</span>
                  <span slot="right">
                    <span class='money'>￥{{ room.MarketPrice * discount(room.IsSpecial) | toZero | fomatFloat  }}</span>
                    <a v-on:click="post(room.AvailRooms,index)">{{room.AvailRooms | nullOrNot}}</a>
                  </span>
                </mu-list-item>-->
      </div>
    </div>
  


    <!--查看图片-->
    <div id="bg_show" v-if="NowPage>1" style="opacity:1;    background: rgba(0,0,0,0.9); "   >
      <div style=" right:5% ; padding-top:0.5rem;position:fixed  " v-on:click="CloseLook()">
        <img src="../../../static/service/Close.png" style=" width:0.55rem ;" />
      </div>
      <div style=" left:8% ; padding-top:0.6rem;position:fixed  " v-on:click="goPage2()" v-if="NowPage==3"  >
        <img src="../../../static/service/Back.png" style=" width:0.25rem ;" />
      </div>

      <div v-if="NowPage==2" style="text-align:left ; width:95% ; padding-left:5%; font-size:0.28rem ">
        <div style="color:white; height: 1.5rem"> </div>

        <div style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "> </div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; "> 外观与周边 </div>
        <span v-for="  (pic,index)  in g_currentInfo.PicList1" style="  "  >
          <img :src="pic.Attachmenturl" style="width:50%;padding:2%;"  v-on:click=" goPage3('外观与周边' , index) " /> 
        </span>
        
        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "> </div>
        <div style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "> </div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; "> 公共设施 </div>
        <span v-for="  (pic,index)  in g_currentInfo.PicList2" style="  "  >
          <img :src="pic.Attachmenturl" style="width:50%;padding:2%;"  v-on:click=" goPage3('公共设施' , index ) " /> 
        </span>
        
        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "> </div>
        <div style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "> </div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; "> 客房 </div>
        <span v-for="  (pic,index)  in g_currentInfo.PicList3" >
          <!--{{pic.IsLogImage}}-->
          <img :src="pic.Attachmenturl" style="width:50%;padding:2%;"  v-on:click=" goPage3('客房' , index ) " /> 
        </span>
        
        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "> </div>
        <div style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "> </div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; "> 早餐 </div>
        <span v-for="  (pic,index)  in g_currentInfo.PicList4" style="  "  >
          <img :src="pic.Attachmenturl" style="width:50%;padding:2%;"  v-on:click=" goPage3('早餐' , index ) " /> 
        </span>

        <div style="height: 2.5rem"> </div>
      </div>

      <div v-if="NowPage==3" style="opacity:1 ; text-align:left ;  font-size:0.28rem ">
        
        <div style=" height: 1.8rem"      > </div>
        <div style=" font-size:0.32rem ; color:#fff ;   text-align:center"      >             {{ NowPicName }}        </div>
        <div style=" height: 1.1rem"       > </div>

        <swiper :options="swiperOption2"  >
          <swiper-slide v-for="pic in TmpPicList" style="padding-bottom:1rem"  >
            <img :src="pic.Attachmenturl"  style="width:100%;"    >
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" ></div>
        </swiper>

        <div style=" height: 2.5rem"  v-on:click="goPage2()"  > </div>
      </div>

    </div>
  
    <mu-toast v-if="toast" id="alertline" v-bind:message="hintMes" @close="hideToast" />

 

   <!--弹出框 选择是否-->
    <pop
      :display="popDisplay"
      @closeHandler="closePop"
      @okHandler="closeYES"
      title="提示"
      :msg="popMsg"
      :onlyOk="popOnlyOk"
    />

  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import date from '../../utils/dateextend.js'
import api from '../../api'
import service from '../../utils/hotelService.js'
 

export default {
  data() {
    return {
      swiperOption1: {
        pagination: '.swiper-pagination',
        // loop:true,
        paginationClickable: true,
        autoplay: 5000,
      },
      swiperOption2: {
        pagination: '.swiper-pagination',
        // loop:true,
        paginationType: 'fraction'
      },


      banners: [],
      // homes: [],
      bottomPopup: false,
      current: { FinalPrice: [] },
      starColor: 'white',
      starValue: 'star_outline',
      collectState: false,
      hintMes: '',
      toast: false,
      hotelInfo: '',
      rooms: [],
      cards: '',
      currentIndex: '',
      hotelCode: '',
      loading: false,
      change: false,

      relaxHour: '',

      firstroom: '',

      // 登录状态
      loginState: false,
      popDisplay: false,
      popOnlyOk: false,
      popMsg: "需要先登陆，是否前往登陆？",

      NowPage: 1,
      TmpPicList:[],
      NowPicName: '',

    }
  },
  components: {
    swiper,
    swiperSlide
  },
  filters: {
    nullOrNot(number) {
      if (number <= 0) {
        return "满房";
      }
      return "预订";
    }
    ,
    bfOrNot(hasBf) {
      if (hasBf != '0') {
        return "含早";
      }
      return "无早"
    }
  },

  activated() {

    // 尝试获取外挂的参数
    if ( this.$route.query.hotelcode != undefined ){
      var model = this.g_currentInfo;
      model.HotelCode = this.$route.query.hotelcode ;
      this.setG_currentInfo(model);
    }

   if(this.$route.query.checkInDate!=undefined){
      var model1 = this.g_searchParam;
      model1.HotelCode = this.$route.query.checkInDate ;
      this.setG_searchParam(model1);
         // this.g_searchParam.arriveDate =this.$route.query.checkInDate;  //return new Date(this.$route.query.checkInDate).Format('M月D日');
      } 
    this.gethoteldetal();


    this.checkDateOut()
    this.getRoomList();

    //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {
      if (res.Result) {
        this.loginState = true
        this.checkHotel()
      }
      else {
         if (this.$route.query.userId!=undefined && this.$route.query.sign!=undefined) {
              this.CheckLogin();
        }else{
             this.loginState = false
        }
      }
    })

  },
  methods: {
    ...mapMutations({
      setG_currentInfo: 'setG_currentInfo', setG_searchParam: 'setG_searchParam',
      setG_currentRoom: 'setG_currentRoom', setDiscount: 'setG_currentDiscount',
      setG_UserInfo: "setG_UserInfo"
    }),

    // pop
    closePop() {
      this.popDisplay = false;
    },
    closeYES() {
      this.popDisplay = false;
      this.$router.push({ path: "/user/login" });
    },

    // 查看图片功能
    goPage2() {
      this.NowPage = 2;
      // console.log(this.swiperOption.activeIndex)
    },
    goPage3(name , index) {

      if( name == '外观与周边' )
        this.TmpPicList = this.g_currentInfo.PicList1;
      else if( name == '公共设施' )
        this.TmpPicList = this.g_currentInfo.PicList2;
      else if( name == '客房' )
        this.TmpPicList = this.g_currentInfo.PicList3;
      else if( name == '早餐' )
        this.TmpPicList = this.g_currentInfo.PicList4;

      this.NowPicName = name ;
      this.swiperOption2.initialSlide= index,
      this.NowPage = 3;
    },

    CloseLook() {
      this.NowPage = 1
    },
    // 查看图片功能 END




    goOrderToRelax(room) {
      console.log("beging test")
      //未登录
        if (!this.loginState) {
          this.popDisplay = true;
          this.popMsg = "预订请先登录!是否前往登录页？";
          return;
        }
      room.hotelCode = this.g_currentInfo.HotelCode
      this.setG_currentRoom(room);

      console.log(room)

      this.$router.push({ path: '/search/makeOrderToRelax' });
    },



    goback() {
      // this.$router.push({ path: '/search/ListToRelax' });
      this.$router.go(-1)
      // javascript: history.go(-1);
    },

    gethoteldetal(){
      this.loading = true;

      console.log(this.g_currentInfo.HotelCode)
      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
      params.append('startDate', this.g_searchParam.startDate);
      params.append('endDate', this.g_searchParam.endDate);
      this.$http.post(api.getHotelDetail(),params.toParam()).then((res) => {
        if(res.Result){
          this.setG_currentInfo(res.Data);
          this.loading = false;
        }
      })
    },
        
    getRoomList() {
      this.rooms = []
      var params = new this.URLSearchParam();
      params.append('HotelCode', this.g_currentInfo.HotelCode);
      if(this.$route.query.checkInDate!=undefined){
         params.append('checkInDate', this.$route.query.checkInDate);
      } else{
      params.append('checkInDate', this.g_searchParam.arriveDate);
      }
      this.$http.post(api.GetRelaxRoomTypeList(), params.toParam()).then((res) => {

        if (res.Result) {
          console.log('loadRoomData...')
          // this.rooms = res.Data[0];
          // this.cards = res.Data[1];
          this.rooms = res.Data;
          console.log(this.rooms)
          // 预定小时限制
          this.firstroom = this.rooms[0];

        }
        else {
          console.log(res)
        }
      })
    },


    checkHotel() {
      // 判断该酒店是否已收藏
      this.$http.post(api.getMyHotel()).then((res) => {
        if (res.Result) {
          for (var index in res.Data) {
            if (this.g_currentInfo.HotelCode == res.Data[index].HotelCode) {

              this.starValue = 'star';
              this.starColor = '#FFB03B';
              this.collectState = true
              
              return
            }
          }
          this.starValue = 'star_outline';
          this.starColor = 'white';
          this.collectState = false
        }
        else {
        }
      })
    },
    collect() {
      console.log( this.loginState   )

      if (this.loginState) {
        if (!this.collectState) {
          this.addHotel()
        }
        else {
          this.deleteHotel()
        }
      }
      else {
        this.starValue = 'star_outline';
        this.starColor = 'white';
        this.hintMes = '登录后才能收藏哦！'
        this.showToast()
      }
    },
    addHotel() {
      //收藏酒店
      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
      this.$http.post(api.addMyHotel(), params.toParam()).then((res) => {
        console.log(res)
        if (res.Result) {
          this.hintMes = res.Data;
          this.starValue = 'star';
          this.starColor = '#FFB03B';
          this.collectState = true;
        }
        else {
          this.hintMes = res.Message;
        }
        this.showToast();
      })
    },
    deleteHotel() {
      //取消已收藏酒店
      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
      this.$http.post(api.DeleteMyHotel(), params.toParam()).then((res) => {
        console.log(res)
        if (res.Result) {
          this.hintMes = res.Data;
          this.starValue = 'star_outline';
          this.starColor = 'white';
          this.collectState = false;
        }
        else {
          this.hintMes = res.Message;
        }
        this.showToast();
      })
    },

    open(index) {
      this.current = this.rooms[index];
      this.currentIndex = index;
      this['bottomPopup'] = true;
    },
    close(position) {
      this['bottomPopup'] = false
    },
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },

    goCommentList() {
      this.$router.push({ path: '/hotel/CommentList' });
    },
    //初始化日期
    initDate() {
      var nowDate = new Date();
      var inDate = nowDate.Format("yyyy-MM-dd");//入住日期为当天

      this.setRelaxDate(inDate);

    },
    //检查时间是否超时（入住时间小于今天）
    checkDateOut() {

      if(this.g_searchParam.startDate ==''){
        this.initDate();
      }
      else{
        var day = date.daysBetween(new Date().Format("yyyy-MM-dd"), this.g_searchParam.startDate)
        if (day < 0) {
          this.initDate()
        }
      }
    },

    // 全日房得到入住日期
    setRelaxDate(arriveDate) {
      var searchParam = this.g_searchParam;
      searchParam.arriveDate = arriveDate;
      this.setG_searchParam(searchParam);
      this.getRoomList();

    },

    // 全日房  开始时间 如：11
    setRelaxHour(relaxHour) {
      this.relaxHour = relaxHour;
      var searchParam = this.g_searchParam;
      searchParam.relaxHour = relaxHour;
      this.setG_searchParam(searchParam);

      this.HotelList = [];
      // this.searchHotel();

    },

   // 检验是否登入，APP 小程序 跳转到该页面需要检索到自动登入 功能
    CheckLogin(){
     if (this.$route.query.userId!=undefined && this.$route.query.sign!=undefined) {
       console.log("-----------------------------")
       console.log(this.$route.query.userId+"---"+this.$route.query.sign)
       
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.userId);
      params.append("sign", this.$route.query.sign);
 
      this.$http.post(api.CheckLoginState(), params.toParam()).then(data => {
        if(data.Result){ 
            this.loginState=true;
             // 自动登入成功--保存登录信息
            var result = data.Data
            this.SaveUserInfo(result)
          }
        });
        }
    },

    SaveUserInfo(result) {
      // 保存登录信息
      var UserInfo = result
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
      console.log(UserInfo)
      // 保存登录信息
      this.setG_UserInfo(UserInfo)
    },

    fullStar(input) {
      return Math.floor(input);
    },
    nullStar(input) {
      return Math.floor(5 - input);
    },
    halfStar(input) {
      if (this.fullStar(input) == input) {
        return false;
      }
      return true;
    },
    serviceIcon: service.serviceIcon,
    //按卡类型和房间类型计算折扣
    discount(isSp) {
      if (isSp) {
        return 1
      }
      for (var index in this.cards) {
        let card = this.cards[index];
        if (card.ic_kindname == this.g_UserInfo.Card_Kind_Diplay) {
          return card.ic_kindzk;
        }
      }
      return 1
    },
  },
  computed: {
    ...mapGetters([
      'g_currentInfo', 'g_searchParam', 'g_UserInfo'
    ]),
    day() {
      var d1 = new Date(this.g_searchParam.arriveDate)
      var d2 = new Date(this.g_searchParam.endDate)
      var s1 = d1.getTime(), s2 = d2.getTime();
      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
    },
    arriveDateFormat(){
      if(this.$route.query.checkInDate!=undefined){
          this.g_searchParam.arriveDate =this.$route.query.checkInDate;  //return new Date(this.$route.query.checkInDate).Format('M月D日');
      } 
      return new Date(this.g_searchParam.arriveDate).Format('M月D日');
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date()
    },
    checkinMaxDate() {
      //最大入住日期为3个月内
      return new Date().DateAdd('d', 89)//入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.arriveDate).DateAdd('d', 1)
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.arriveDate).DateAdd('d', 14)
    },
  },

}
</script>























<style lang="less">
@import "../../assets/theme.less";
.roomDetail {
  width: 100%;
  height: auto;
  .title {
    color: @primaryBlack;
    font-size: 0.32rem;
    padding-top: 0.3rem;
  }
  .attrs {
    list-style: none;
    padding-left: 10px;
    margin-top: 10px;
    color: @secondBlack;
    font-size: 0.26rem;
    label {
      color: @primaryBlack;
    }
  }
  .bottom {
    .invalid {
      color: #cccccc !important;
      background-color: #EEEEEE !important;
    }
    margin-top:0.15rem;
    display:flex;
    display: -webkit-flex;
    .left {
      width: 5.8rem;
      padding: 0px;
      display: inline-block;
      margin: 0 0 0 0;
      font-size: 0.26rem;
      color: @primaryBlack;
      span.card {
        width: 2.6rem;
        display: inline-block;
        padding: 0;
        margin: 0;
        color: @secondBlack;
        font-size: 0.22rem;
      }
      .price {
        color: @primaryOrange;
        font-size: 0.3rem;
      }
      .del {
        text-decoration: line-through;
      }
    }
    .right {
      width: 1.3rem;
      display: inline-block;
      margin: auto;
      a {
        color: white;
        background-color: @primaryColor;
        padding: 5px 10px;
        border-radius: 4px;
      }
    }
  }
}

.orange {
  color: @primaryOrange;
}

.noRoom {
  a,
  .listTitle,
  span {
    color: #cccccc !important;
  }
  a {
    background-color: #EEEEEE !important;
  }
}

.isChild {
  background-color: #F4F4F4 !important;
  position: relative;
}

.firstChild:before {
  content: '';
  width: 24px;
  height: 12px;
  display: block;
  background-color: #F4F4F4;
  position: absolute;
  top: -12px;
  left: 20px;
  background: linear-gradient(135deg, transparent 8.5px, #F4F4F4 0) left,
  linear-gradient(-135deg, transparent 8.5px, #F4F4F4 0) right;
  background-size: 12px 12px;
  background-repeat: no-repeat;
}

.paper {
  .mu-list {
    padding-top: 0px;
    .listTitle {
      color: @secondBlack;
      font-size: 0.28rem;
      margin-top: 0px;
      position: relative;
    }
    .color {
      font-size: 0.2rem;
      padding: 0.02rem 0.05rem 0 0.03rem;
      color: white;
      border: 3px;
      margin-right: 3px;
    }
    .is10 {
      background-color: #FFB03B;
    }
    .is20 {
      background-color: #FF8F3B;
    }
    .is30 {
      background-color: #B5D054;
    }
    .mu-item-wrapper {
      border-bottom: 0.02rem solid #F1F1F1;
    }
    .mu-item-right {
      width: 3.25rem;
      font-size: 0.24rem;
      color: @textColor;
      .money {
        display: inline-block;
        width: 3em;
        text-align: right;
        color: @primaryOrange;
        font-size: 0.32rem;
        margin: 0 5px;
      }
      a {
        color: white;
        padding: 5px 10px;
        background-color: #27BA69;
        font-size: 0.28rem;
        border: 2px;
      }
    }
  }
}

.top {
  padding: 0px;
  .mu-text-field-input {
    width: 2rem;
    color: @secondBlack;
    font-size: 0.28rem;
    height: 18px;
    top: 8px;
    left: -0.29rem;
  }
}
</style>

<style lang="less" scoped>
@import "../../assets/theme.less";
.paper {
  text-align: left;
  .top {
    text-align: center;
    margin-top: 10px;
    width: 100%;
    height: 1.21rem;
    display: flex;
    display: -webkit-flex;
    margin-bottom: 0rem;
    div {
      width: 33%;
      display: inline-block;
      margin: auto;
      color: @secondBlack;
      font-size: 0.28rem;
      small {
        font-size: 0.22rem;
        color: @textColor;
        position: relative;
        top: 0.2rem;
      }
    }
    .left {
      float: left;
    }
    .middle {
      span {
        color: @primaryOrange;
      }
    }
    .right {
      float: right;
    }
  }
}

.slider {
  position: absolute;
  top: 0px;
  z-index: -1;
  img {
    max-height: 3.611rem;
  }
}

.main {
  width: 7.5rem;
  background-color: #F0F0F0;
  position: absolute;
  top: 3.611rem;
  text-align: center;
}

.demo-paper {
  display: inline-block;
  min-height: 2.71rem;
  width: 6.91rem;
  text-align: left;
  position: relative;
  top: -7px;
  .title {
    color: @secondBlack;
    font-size: 0.3rem;
    display: inline-block;
    font-weight: 600;
    margin-top: 10px;
    padding: 0 5px 0 15px;
  }
  .rightArr {
    font-size: 18px;
    color: @textColor;
    font-weight: 100
  }
  p {
    text-align: left;
    padding: 0 5px 0 15px;
    margin: 0.14rem 0;
    font-size: 0.22rem;
    .map {
      background-color: #ECF7F1;
      color: #9DCAB1;
      padding: 3px;
      margin-left: 1em;
    }
    .score {
      color: @primaryOrange;
      font-size: 0.42rem;
    }
    .unit {
      color: @secondBlack;
    }
    .stars {
      margin-left: 25px;
    }
    .commont {
      margin-left: 15px;
      color: @textColor;
      font-size: 0.22rem;
    }
  }
}
</style>








// WEBPACK FOOTER //
// homeListToRelax.vue?37f3758a